import React, { useState } from 'react';
import PhotoLightbox from './PhotoLightbox';
import { Image as ImageIcon } from 'lucide-react';
import { OptimizedImage } from './ui/optimized-image';

const PhotoGallery = ({ photos = [], columns = 4 }) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  if (!photos || photos.length === 0) {
    return null;
  }

  // Construire les URLs complètes pour les photos
  const fullPhotos = photos.map(photo => 
    photo.startsWith('http') 
      ? photo 
      : `${process.env.REACT_APP_BACKEND_URL}${photo}`
  );

  const handlePhotoClick = (index) => {
    setSelectedIndex(index);
    setLightboxOpen(true);
  };

  return (
    <>
      {/* Section Album Photo */}
      <div className="mt-8">
        <h3 
          className="text-2xl font-bold mb-4 flex items-center gap-2"
          style={{ fontFamily: '"Lora", serif', color: 'rgb(196, 150, 96)' }}
        >
          <ImageIcon className="w-6 h-6" />
          Album Photo
        </h3>
        
        {/* Grille de miniatures optimisées */}
        <div 
          className="grid gap-3"
          style={{
            gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`
          }}
        >
          {fullPhotos.map((photo, index) => (
            <div
              key={index}
              onClick={() => handlePhotoClick(index)}
              className="relative group cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300"
              style={{ paddingBottom: '75%' }} // Ratio 4:3
            >
              <OptimizedImage
                src={photo}
                alt={`Photo ${index + 1}`}
                className="absolute inset-0 w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-300"
                useThumbnail={true}
              />
              
              {/* Overlay au survol */}
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center">
                <ImageIcon className="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              
              {/* Numéro de la photo */}
              <div className="absolute bottom-2 right-2 bg-black bg-opacity-70 text-white px-2 py-1 rounded text-xs font-semibold">
                {index + 1}
              </div>
            </div>
          ))}
        </div>

        {/* Info */}
        <p className="text-sm text-gray-500 mt-3 text-center" style={{ fontFamily: '"Lora", serif' }}>
          Cliquez sur une photo pour l'agrandir • {fullPhotos.length} photo{fullPhotos.length > 1 ? 's' : ''}
        </p>
      </div>

      {/* Lightbox */}
      {lightboxOpen && (
        <PhotoLightbox
          photos={fullPhotos}
          initialIndex={selectedIndex}
          onClose={() => setLightboxOpen(false)}
        />
      )}
    </>
  );
};

export default PhotoGallery;
